/*
 * Project: LegalPlace assistant
 * File: src/app/refs/customizations.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpCustomizations {
  constructor() {
    this.custom = {};
  }

  buildCustomizations(modelParam) {
    this.custom = modelParam;
  }

  get(index) {
    if (this.custom && this.custom[index]) return this.custom[index];
    return 'NONE';
  }
}


export default LpCustomizations;



// WEBPACK FOOTER //
// ./src/app/refs/customizations.js